import axios from "axios";
import { BASE_URL } from "./Envirements";
import { getGlobalStore } from "../context/GlobalContext";

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Request interceptor - add auth token to requests
instance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("authTokens"));
    const store_id = getGlobalStore();

    if (!token) {
      // Don't redirect here, let the response interceptor handle it
      return config;
    }

    config.headers.Authorization = `JWT ${token}`;

    if (store_id) {
      config.headers["x-store-id"] = store_id;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle token refresh on 401
instance.interceptors.response.use(
  (response) => response,
  async (err) => {
    const originalConfig = err.config;

    // If error response exists and is 401 (Unauthorized)
    if (err.response && err.response.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;

      try {
        const refreshToken = JSON.parse(localStorage.getItem("refreshToken"));

        if (!refreshToken) {
          // No refresh token, redirect to login
          clearAuthAndRedirect();
          return Promise.reject(err);
        }

        // Try to refresh the access token
        const response = await axios.post(`${BASE_URL}/refresh-token`, {
          refresh_token: refreshToken
        });

        if (response.data.success && response.data.data?.access_token) {
          const newAccessToken = response.data.data.access_token;

          // Store the new access token
          localStorage.setItem("authTokens", JSON.stringify(newAccessToken));

          // Update the original request with new token and retry
          originalConfig.headers.Authorization = `JWT ${newAccessToken}`;
          return instance(originalConfig);
        } else {
          // Refresh failed, clear auth and redirect
          clearAuthAndRedirect();
          return Promise.reject(err);
        }
      } catch (refreshError) {
        // Refresh token request failed, clear auth and redirect
        clearAuthAndRedirect();
        return Promise.reject(refreshError);
      }
    }

    // Handle 403 (Forbidden) - only logout if account is disabled
    if (err.response && err.response.status === 403) {
      const errorMessage = err.response.data?.message;

      // Only logout if account is disabled, not for insufficient permissions
      if (errorMessage === 'ACCOUNT_DISABLED' || errorMessage === 'NO_USER_FOUND') {
        clearAuthAndRedirect();
      }
      // For ADMIN_ACCESS_REQUIRED, just reject the error, don't logout
    }

    return Promise.reject(err);
  }
);

// Helper function to clear auth data and redirect to login
const clearAuthAndRedirect = () => {
  localStorage.removeItem("authTokens");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  window.location.replace('/Login');
};

export default instance;

